import React from 'react';
import { createState, useState } from '@hookstate/core';
import { User } from 'oidc-client';

const authStore = createState<User | null>(null);

export default authStore;
